export default "__VITE_ASSET__DOzttiv3__"